import joi from "joi";
import { BaseTypeSchema } from "./schema/BaseTypeSchema";
import { ObjectSchema } from "./schema/type/ObjectSchema";
import { JoiBuilder } from "./JoiBuilder";
import { ErrorOperation } from "namirasoft-core";
import { BaseVariableSchema } from "./schema/BaseVariableSchema";

export class JoiValidator
{
    static validate(schema: BaseTypeSchema | null, obj: any, name: string | null): string | null
    {
        name = name ?? "value";
        let builder = new JoiBuilder(schema);
        let jschema = builder.runSynch(() => { });
        if (jschema != null)
        {
            if (!obj)
            {
                if (schema?.required)
                    return `"${name}" must not be undefined or null`;
                return null;
            }
            const validation = joi.compile(jschema)
                .prefs({ errors: { label: 'key' } })
                .validate(obj);
            if (validation.error)
                return validation.error.details.map((details) => details.message).join(', ');
        }
        else
        {
            if (obj != null)
            {
                let empty_object = Object.keys(obj).length == 0;
                let empty_array = Array.isArray(obj) && obj.length == 0
                if (!(empty_object || empty_array))
                    return `"${name}" must be of type null or undefined`;
            }
        }
        return null;
    }
    static validateArray(variables: BaseVariableSchema[] | null, obj: any, name: string | null): string | null
    {
        return JoiValidator.validate(new ObjectSchema("", true, variables), obj, name);
    }
    static check(variable: BaseTypeSchema | null, obj: any, name: string | null): void
    {
        let message = JoiValidator.validate(variable, obj, name);
        if (message)
            ErrorOperation.throwHTTP(400, message);
    }
    static checkArray(variables: BaseVariableSchema[] | null, obj: any, name: string | null): void
    {
        let message = JoiValidator.validateArray(variables, obj, name);
        if (message)
            ErrorOperation.throwHTTP(400, message);
    }
}